<template>
  <component :id="id" :is="updateComponent" :class="classes" :style="styles">
    <span v-html="$t(html)"></span>
  </component>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'paragraph-component',
  props: {
    id: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'Empty paragraph'
    },
    action: {
      type: [Object, Array],
      default: () => ({})
    },
    variables: {
      type: Object,
      default: () => ({})
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    classes: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const updateComponent = computed(() => {
      if (props.classes.includes('heading')) {
        return 'h1'
      } else if (props.classes.includes('subHeading')) {
        return 'h2'
      } else {
        return 'p'
      }
    })

    const html = computed(() => {
      let result = props.text
      if (props.variables) {
        for (const variable in props.variables) {
          let value = ''
          result = result.replace(`{${variable}}`, value)
        }
      }
      return result
    })

    return {
      updateComponent,
      html
    }
  }
}
</script>

<style scoped lang="scss">

.subHeading {
  font-size: 18px;
  font-weight: 600;
}
</style>
